<section>
  <div mat-dialog-title>
    <h1 fxFlexAlign="start">{{data.title}}</h1>
    <div class="box"
         fxLayout="row"
         fxLayoutAlign="space-between center">
      <span class="box-text">{{data.text}}</span>
    </div>
  </div>

  <mat-dialog-content fxLayout="column"
                      fxLayoutAlign="start start">
    <form [formGroup]="form"
          class="w-100">
      <mat-form-field class="w-100"
                      appearance="outline">
        <input autocomplete="off"
               formControlName="comments"
               [placeholder]="data.placeholder"
               matInput />
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end"
                      fxLayout="row"
                      fxLayoutAlign="space-between center">
    <button mat-dialog-close
            mat-stroked-button>
      <mat-icon>close</mat-icon>
      <span>CANCELAR</span>
    </button>
    <button color="primary"
            mat-raised-button
            type="submit"
            (click)="fillComments()"
            [mat-dialog-close]="data"
            [disabled]="form.invalid">
      <mat-icon>save</mat-icon>
      <span>SALVAR</span>
    </button>
  </mat-dialog-actions>
</section>
